<template>
  <div id="itemBlock">
    <v-row>
      <v-col>
        <v-btn
          class="primary my-2 mx-1"
          :disabled="!canAddManifest"
          @click="addItemButtonClickEvent"
        >
          品目の追加
        </v-btn>
      </v-col>
    </v-row>
    <v-tabs
      v-model="selectedTab"
      show-arrows
      align-with-title
      background-color="blue-grey lighten-4"
    >
      <v-tabs-slider />
      <v-tab
        v-for="manifest in filteredManifests"
        :key="manifest.key"
      >
        {{ manifest.item_name || '未設定' }}
      </v-tab>
    </v-tabs>
    <v-card-text class="pt-0">
      <v-row v-if="false">
        <v-col class="text-right">
          <v-btn
            class="error"
            :disabled="!canRemoveManifest"
            @click="removeItemButtonClickEvent"
          >
            品目の削除
          </v-btn>
        </v-col>
      </v-row>
      <v-tabs-items v-model="selectedTab">
        <v-tab-item
          v-for="(manifest, index) in filteredManifests"
          :key="manifest.key"
        >
          <sales-item-block-form
            :key="`manifest-${manifest.key}`"
            :manifest="manifest"
            :tab-index="index"
            :can-remove="canRemoveManifest"
            :callable-type="callableType"
            :items="items"
            :hazardous-substances="hazardousSubstances"
            :load-by-emission="loadByEmission"
            :sales-item-price-details="salesItemPriceDetails"
            :quantity-units="quantityUnits"
            :quantity-confirms="quantityConfirms"
            :packings="packings"
            :transportations="transportations"
            :disposal-methods="disposalMethods"
            :master-mode="masterMode"
            :dxe-manifest="dxeManifest"
            :selectedEmission="selectedEmission"
            :freeTypeEmission="freeTypeEmission"
            @changeManifestTypeCallback="changeManifestTypeCallback"
            @removeItem="removeItemButtonClickEvent"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </div>
</template>

<script>
import SalesItemBlockForm from './_SalesItemBlockForm'
import { mapActions } from 'vuex'

export default {
  name: 'SalesItemBlock',
  components: {
    SalesItemBlockForm,
  },
  mixins: [],
  props: {
    /**
     * 動作モード
     * collection: 受注登録
     * self_emission: 排出自己運搬
     * proxy_request: 他社運搬
     * general: 一般廃棄物
     */
    callableType: {
      type: String,
      default: null,
    },
    /**
     * 排出事業者ID
     */
    emissionId: {
      type: Number,
      default: () => null
    },
    /**
     * 詳細
     */
    manifests: {
      type: Array,
      default: () => [],
    },
    /** マスターからの登録の場合はtrue */
    masterMode: {
      type: Boolean,
      default: () => true
    },
    /** EDIである場合はtrue */
    dxeManifest: {
      type: Boolean,
      default: () => false
    },
    quantityUnits: {
      type: Array,
      default: () => [],
    },
    hazardousSubstances: {
      type: Array,
      default: () => [],
    },
    quantityConfirms: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    packings: {
      type: Array,
      default: () => [],
    },
    transportations: {
      type: Array,
      default: () => [],
    },
    disposalMethods: {
      type: Array,
      default: () => [],
    },
    manifestType: {
      type: String,
      default: null
    },
    selectedEmission: {
      type: Object,
      default: () => null
    },
    freeTypeEmission: {
      type: Object,
      default: () => null
    },
    loadByEmission: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectedTab: null,
      salesItemPriceDetails: [],
    }
  },
  computed: {
    filteredManifests () {
      let values = []
      for (const manifest of this.manifests) {
        if (!manifest._destroy && !manifest?.split_target) {
          values.push(manifest)
        }
      }
      return values
    },
    canAddManifest () {
      if (this.filteredManifests.length >= 50) {
        return false
      }
      return true
    },
    canRemoveManifest () {
      if (this.filteredManifests.length <= 1) {
        return false
      }
      const manifest = this.filteredManifests[this.selectedTab]
      if (manifest && manifest.already_registered) {
        return false
      }
      return true
    },
  },
  watch: {
    emissionId (newValue) {
      if (newValue) {
        this.fetchSalesItemPriceDetails({ id: newValue, type: 'Emission', only_jwnet_item: true }).then((content) => {
          this.salesItemPriceDetails = content.sales_item_price_details
        })
      }
    },
  },
  created() {
    if (this.emissionId) {
      this.fetchSalesItemPriceDetails({ id: this.emissionId, type: 'Emission', only_jwnet_item: true }).then((content) => {
        this.salesItemPriceDetails = content.sales_item_price_details
      })
    }
  },
  methods: {
    ...mapActions('DriverMasterSearchSupplierSalesItemPriceDetail', {
      fetchSalesItemPriceDetails: 'index',
    }),
    /**
     * マニフェストの追加を行う.
     */
    addItemButtonClickEvent () {
      this.$emit('addManifestCallback');
    },
    /**
     * マニフェストの削除を行う
     */
    removeItemButtonClickEvent () {
      for (let i = 0; i < this.filteredManifests.length; i++) {
        if (this.selectedTab === i) {
          this.filteredManifests[i]._destroy = true
          this.changeManifestTypeCallback()
          setTimeout(() => {
            this.$vuetify.goTo('#itemBlock', {duration: 500, offset: 0, easing: 'easeInOutCubic'})
          }, 100)
        }
      }
    },
    switchToNewTab () {
      this.selectedTab = this.filteredManifests.length - 1
      this.$vuetify.goTo('#itemBlock', {duration: 100, offset: 0, easing: 'easeInOutCubic'})
    },
    changeManifestTypeCallback (manifest) {
      this.$emit('changeManifestTypeCallback', manifest)
    },
  }
}
</script>

<style scoped lang="scss">

</style>
